import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-[300px]" }
const _hoisted_2 = {
  key: 0,
  class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg"
}
const _hoisted_3 = { class: "w-full min-w-[1180px] table-fixed border-collapse" }
const _hoisted_4 = { class: "bg-[#f0f0f4]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 w-10 h-10 rounded-full bg-slate-200" }),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-28 bg-slate-200 rounded" }),
      /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-16 bg-slate-200 rounded" })
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-24 bg-slate-200 rounded" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-32 bg-slate-200 rounded" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-6 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-20 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-6 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-20 bg-slate-200 rounded-full" })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "px-3 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-8 w-20 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_13 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useHandoverStore } from '@/pinia-store/useHandoverStore'
import type { AdminQueueResponse } from '@/Network/Types/Responses/HandoverInviteResponses'
import HandoverFilterBar from './components/HandoverFilterBar.vue'
import HandoverApprovalsTable from './components/HandoverApprovalsTable.vue'
import EmptyList from '@/components/EmptyList.vue'
import HandoverHistoryModal from './components/HandoverHistoryModal.vue'
import HandoverHistoryDetailModal from './components/HandoverHistoryDetailModal.vue'

// Espelha as colunas de HandoverApprovalsTable.vue para o skeleton não "pular" ao carregar

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const skeletonColumns = [
  { label: 'Profissional que está passando', width: 'w-[230px]' },
  { label: 'Escala', width: 'w-[160px]' },
  { label: 'Unidade', width: 'w-[170px]' },
  { label: 'Profissionais que querem assumir', width: 'w-[150px]' },
  { label: 'Data do convite', width: 'w-[110px]' },
  { label: 'Plantões', width: 'w-[90px]' },
  { label: 'Expiração', width: 'w-[140px]' },
  { label: 'Ações', width: 'w-[130px]' }
]

const router = useRouter()
const handoverStore = useHandoverStore()
const { pendingApprovals, isLoading, meta } = storeToRefs(handoverStore)

const currentPage = ref(1)
const showHistoryModal = ref(false)
const showDetailModal = ref(false)
const detailItem = ref<AdminQueueResponse | null>(null)

// A linha já traz o pacote completo: guardá-lo no store deixa a página de
// detalhes abrir sem nova requisição (ela só busca quando o pacote não bate).
const handleViewTransitionDetails = (item: AdminQueueResponse) => {
  handoverStore.setCurrentEvaluation(item)
  router.push({
    name: 'HandoverDetails',
    params: { packageId: String(item.package.id) }
  })
}

// A linha da listagem já carrega tudo que o modal de detalhes mostra — reusamos o
// mesmo modal do histórico em vez de duplicar a tela ou refazer a requisição.
const handleViewDetails = (item: AdminQueueResponse) => {
  detailItem.value = item
  showDetailModal.value = true
}

const changePage = (page: number) => {
  currentPage.value = page
  handoverStore.fetchPendingApprovals(page)
}

const handleEvaluate = (item: AdminQueueResponse) => {
  handoverStore.setCurrentEvaluation(item)
  router.push({
    name: 'HandoverEvaluation',
    params: { packageId: String(item.package.id) }
  })
}

const handleViewHistory = () => {
  showHistoryModal.value = true
}

const closeAllFilters = () => {
  // Propaga click para fechar dropdowns de filtros
}

watch(
  () => meta.value.page,
  (newPage) => {
    currentPage.value = newPage
  }
)

onMounted(() => {
  handoverStore.fetchPendingApprovals(1)
})

return (_ctx: any,_cache: any) => {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col gap-y-6",
    onClick: closeAllFilters
  }, [
    _createVNode(HandoverFilterBar, { onViewHistory: handleViewHistory }),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isLoading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skeletonColumns, (col) => {
                    return _createElementVNode("th", {
                      key: col.label,
                      class: _normalizeClass(["px-3 py-2.5 text-[13px] font-bold text-[#272735] text-center leading-tight align-middle", col.width])
                    }, _toDisplayString(col.label), 3)
                  }), 64))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createElementVNode("tr", {
                    key: n,
                    class: "border-t border-[#e8e8ed] bg-white animate-pulse"
                  }, _hoisted_13)
                }), 64))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(pendingApprovals).length > 0)
              ? (_openBlock(), _createBlock(HandoverApprovalsTable, {
                  key: 0,
                  items: _unref(pendingApprovals),
                  onEvaluate: handleEvaluate,
                  onViewTransitionDetails: handleViewTransitionDetails,
                  onViewDetails: handleViewDetails
                }, null, 8, ["items"]))
              : (_openBlock(), _createBlock(EmptyList, {
                  key: 1,
                  title: "Nenhuma aprovação pendente"
                }))
          ], 64))
    ]),
    (!_unref(isLoading) && _unref(pendingApprovals).length > 0)
      ? (_openBlock(), _createBlock(_component_v_pagination, {
          key: 0,
          modelValue: currentPage.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
            changePage
          ],
          "total-visible": 5,
          length: _unref(meta).totalPages,
          density: "comfortable",
          color: "primary",
          "data-testid": "handover-approvals-pagination"
        }, null, 8, ["modelValue", "length"]))
      : _createCommentVNode("", true),
    _createVNode(HandoverHistoryModal, {
      modelValue: showHistoryModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showHistoryModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(HandoverHistoryDetailModal, {
      modelValue: showDetailModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDetailModal).value = $event)),
      item: detailItem.value
    }, null, 8, ["modelValue", "item"])
  ]))
}
}

})